import axios from '@/utils/api'

const actions = {
  async countNovasNotificacoes ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `mensagem/${dados.idDestinatario}/countNovasNotificacoes`
    })
    return data
  },
  async readNotificacoes ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `mensagem/${dados.idDestinatario}/leituraMensagens`
    })
    return data
  },
  async getNotificacoesByFilter ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `mensagem/filtroMensagens`
    })
    return data
  },
  async findNotificacoes ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      data: filtro,
      url: `notificacoes/find`
    })
    return data.notificacoes
  },
  async quantidadeNaoLidas ({ commit }) {
    const data = await axios({
      method: 'GET',
      loader: false,
      url: `notificacoes/quantidadeNaoLidas`
    })
    return data
  },
  async marcarComoLida ({ commit }, {id, idUsuario}) {
    const response = await axios({
      method: 'GET',
      url: `notificacoes/marcarComoLida/${id}/${idUsuario}`
    })
    return response
  },

  async marcarArrayComoLida ({ commit }, idsRecebedor) {
    const response = await axios({
      method: 'POST',
      url: `notificacoes/marcarComoLida`,
      data: idsRecebedor
    })
    return response
  },

  async findLida ({ commit }) {
    const response = await axios({
      method: 'GET',
      url: `recebedor/find`
    })
    return response
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/notificacao.js